import React from 'react';

// Suspense fallback while a lazy page chunk downloads. Kept deliberately
// small and neutral: it flashes for well under a second on a warm cache and
// must not look like a page-level "no data" state.
export const RouteFallback = () => (
  <div className="flex items-center justify-center w-full py-24" aria-busy="true" aria-live="polite">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 dark:border-blue-400" />
  </div>
);

export default RouteFallback;
